module.exports = __webpack_public_path__ + "img/coupon.e78b1631.png";